import { OptionCard } from "./option-card";

export interface ChecklistOption {
  label: string;
  value: number;
}

export interface ChecklistItem {
  displaySection: string;
  label: string;
  options: ChecklistOption[];
}

interface ChecklistSectionProps {
  item: ChecklistItem;
  selectedValue: number | null;
  onSelect: (value: number) => void;
}

export const ChecklistSection = ({
  item,
  selectedValue,
  onSelect,
}: ChecklistSectionProps) => {
  return (
    <div className="flex flex-col gap-3">
      {/* Section label */}
      <div>
        <span className="text-body-sm text-[#000000]">
          [{item.displaySection}]{" "}
        </span>
        <span className="text-body-sm font-bold text-[#000000]">
          {item.label}
        </span>
        <span className="text-body-sm text-[#CB3A31] ml-1">*</span>
      </div>

      {/* Options grid: 2 columns */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {item.options.map((option) => (
          <OptionCard
            key={option.value}
            label={option.label}
            value={option.value}
            selected={selectedValue === option.value}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
};
